<template>
  <div>
    <!-- Dialog de Histórico (lista) — oculto no modo openDirectAdd -->
    <v-dialog
      v-if="!openDirectAdd"
      v-model="internalValue"
      transition="dialog-bottom-transition"
      max-width="1000px"
      scrollable
    >
      <v-card class="ds-dialog">
        <v-card-title class="ds-dialog-header d-flex justify-space-between align-center">
          <div class="d-flex align-center">
            <v-icon color="white" class="mr-2">mdi-bullseye</v-icon>
            <span class="ds-dialog-title">{{ dialogTitle }}</span>
          </div>
          <div class="d-flex align-center">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon color="white" @click="openAddDialog" class="mr-1" v-bind="attrs" v-on="on">
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </template>
              <span>Adicionar objetivo</span>
            </v-tooltip>
            <v-btn icon color="white" class="close-btn" @click="closeDetailsDialog">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </v-card-title>

        <v-card-text class="ds-dialog-body">
          <section v-if="goals.length" class="ds-form-section ds-form-section--flush">
            <v-simple-table class="history-table">
              <thead>
                <tr>
                  <th class="text-left text-uppercase caption font-weight-bold pa-4">Objetivo</th>
                  <th class="text-left text-uppercase caption font-weight-bold pa-4" style="width: 130px">Origem</th>
                  <th class="text-left text-uppercase caption font-weight-bold pa-4" style="width: 90px">Ações</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in goals" :key="item.id" class="history-row">
                  <td class="pa-4">
                    <span class="body-2 font-weight-medium">{{ item.goal }}</span>
                  </td>
                  <td class="pa-4">
                    <v-chip
                      v-if="item.main_goal_catalog_id"
                      x-small
                      color="catOrange"
                      text-color="white"
                    >
                      <v-icon x-small left>mdi-check-decagram</v-icon>
                      Catálogo
                    </v-chip>
                    <span v-else class="body-2 grey--text">Texto livre</span>
                  </td>
                  <td class="pa-4">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon x-small color="catOrange" class="action-btn mr-1" @click="openLinker(item)" v-bind="attrs" v-on="on">
                          <v-icon small>mdi-link-variant</v-icon>
                        </v-btn>
                      </template>
                      <span>Vincular</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn icon x-small color="error" class="action-btn" @click="confirmDelete(item)" v-bind="attrs" v-on="on">
                          <v-icon small>mdi-trash-can-outline</v-icon>
                        </v-btn>
                      </template>
                      <span>Excluir</span>
                    </v-tooltip>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </section>

          <section v-else class="ds-form-section text-center py-8 px-4">
            <v-icon size="56" color="grey lighten-1">mdi-bullseye-arrow</v-icon>
            <p class="body-1 grey--text mt-3 mb-0">Nenhum objetivo registrado.</p>
            <v-btn color="catOrange" outlined small class="mt-4" @click="openAddDialog">
              <v-icon small left>mdi-plus</v-icon>
              Adicionar primeiro objetivo
            </v-btn>
          </section>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog de Adicionar (picker do catálogo + Outro) -->
    <v-dialog v-model="formDialogVisible" max-width="600px" scrollable>
      <v-card class="ds-dialog">
        <v-card-title class="ds-dialog-header d-flex justify-space-between align-center">
          <div class="d-flex align-center" style="position: relative; z-index: 1">
            <v-icon color="white" class="mr-2">mdi-plus-circle-outline</v-icon>
            <span class="ds-dialog-title">Adicionar objetivo</span>
          </div>
          <v-btn icon color="white" class="close-btn" @click="closeFormDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="ds-dialog-body">
          <section class="ds-form-section">
            <div class="ds-form-section__head">
              <div class="ds-form-section__title">
                <v-icon small color="primary" class="mr-2">mdi-bullseye</v-icon>
                <span>Objetivos</span>
              </div>
            </div>
            <CatalogCheckboxPicker
              v-model="selectedItems"
              :catalog="catalog"
              :loading="loadingCatalog"
              color="catOrange"
            />
          </section>
        </v-card-text>

        <v-card-actions class="ds-dialog-actions">
          <v-btn outlined color="primary" @click="closeFormDialog">
            <v-icon left>mdi-close</v-icon>
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="catOrange"
            dark
            :disabled="!canSave"
            :loading="formLoading"
            depressed
            class="px-6"
            @click="saveData"
          >
            <v-icon small left>mdi-plus</v-icon>
            Adicionar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Vincular objetivo ↔ doença (correlação) -->
    <CorrelationLinker
      v-model="linkerOpen"
      source-type="main_goal"
      :source-id="linkerItem ? linkerItem.id : null"
      :source-label="linkerItem ? linkerItem.goal : ''"
      :patient-id="patientId"
      @changed="$emit('data-saved')"
    />
  </div>
</template>

<script>
import { useSnackbar } from "@/composables/useSnackbar";
import {
  createMainGoals,
  deleteMainGoal,
  getMainGoalCatalog,
} from "@/services/mainGoalService";
import { getConditionsByPatient } from "@/services/conditionService";
import CorrelationLinker from "@/features/patients/profile-dashboard/shared/CorrelationLinker.vue";
import CatalogCheckboxPicker from "@/features/patients/profile-dashboard/fields/CatalogCheckboxPicker.vue";

export default {
  name: "EditMainGoalsDialog",

  components: {
    CorrelationLinker,
    CatalogCheckboxPicker,
  },

  props: {
    value: { type: Boolean, default: false },
    dialogTitle: { type: String, default: "Objetivo Principal do paciente" },
    goals: { type: Array, default: () => [] },
    patientId: { type: [String, Number], required: true },
    openDirectAdd: { type: Boolean, default: false },
  },

  setup() {
    const { success, error, warning, erroDeRequisicao } = useSnackbar();
    return { success, error, warning, erroDeRequisicao };
  },

  data() {
    return {
      formDialogVisible: false,
      selectedItems: [],
      formLoading: false,
      catalog: [],
      loadingCatalog: false,
      linkerOpen: false,
      linkerItem: null,
      conditions: [],
      loadingConditions: false,
    };
  },

  computed: {
    internalValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },

    canSave() {
      return !this.formLoading && this.selectedItems.length > 0;
    },
  },

  watch: {
    value(val) {
      if (val && this.openDirectAdd) {
        this.$nextTick(() => this.openAddDialog());
      }
    },
    formDialogVisible(val) {
      if (!val && this.openDirectAdd) {
        this.$emit("input", false);
      }
    },
  },

  methods: {
    closeDetailsDialog() {
      this.$emit("input", false);
    },

    async openAddDialog() {
      this.selectedItems = [];
      this.formDialogVisible = true;
      if (this.catalog.length === 0) {
        this.loadingCatalog = true;
        try {
          this.catalog = await getMainGoalCatalog();
        } catch (err) {
          console.error("Erro ao carregar catálogo de objetivos:", err);
          this.catalog = [];
        } finally {
          this.loadingCatalog = false;
        }
      }
    },

    closeFormDialog() {
      this.formDialogVisible = false;
      this.selectedItems = [];
    },

    async saveData() {
      if (this.selectedItems.length === 0) {
        this.warning("Selecione ao menos um objetivo");
        return;
      }
      this.formLoading = true;
      try {
        await createMainGoals(
          this.patientId,
          this.selectedItems.map((s) => ({
            goal: s.name,
            main_goal_catalog_id: s.catalog_id || null,
          })),
        );
        // salvia-781: guarda antes de fechar o form, que limpa a selecao.
        const registrado = this.selectedItems;
        this.success("Objetivo(s) adicionado(s) com sucesso!");
        this.closeFormDialog();
        this.$emit("data-saved", registrado);
      } catch (err) {
        console.error("Erro ao salvar objetivo:", err);
        this.erroDeRequisicao(err, err.response?.data?.message || "Erro ao salvar o objetivo");
      } finally {
        this.formLoading = false;
      }
    },

    async openLinker(item) {
      this.linkerItem = item;
      if (this.conditions.length === 0) {
        this.loadingConditions = true;
        try {
          this.conditions = await getConditionsByPatient(this.patientId);
        } catch (err) {
          console.error("Erro ao carregar condições:", err);
          this.conditions = [];
        } finally {
          this.loadingConditions = false;
        }
      }
      this.linkerOpen = true;
    },

    async confirmDelete(item) {
      const ok = await this.$confirm({
        type: "delete",
        title: "Confirmar exclusão",
        message: `Tem certeza que deseja remover "${item.goal}"?`,
        hint: "Esta ação não poderá ser desfeita.",
      });
      if (!ok) return;
      try {
        await deleteMainGoal(item.id);
        this.success("Objetivo removido com sucesso!");
        this.$emit("data-deleted");
      } catch (err) {
        console.error("Erro ao excluir objetivo:", err);
        this.erroDeRequisicao(err, err.response?.data?.message || "Erro ao remover o objetivo");
      }
    },
  },
};
</script>

<style scoped>
.ds-dialog {
  border-radius: 4px !important;
  overflow: hidden;
  box-shadow: 0 24px 60px rgba(31, 77, 63, 0.18), 0 4px 12px rgba(0, 0, 0, 0.06) !important;
}
.ds-dialog-header {
  background: linear-gradient(135deg, var(--ds-primary) 0%, var(--ds-primary-deep) 100%);
  color: var(--ds-white);
}
.ds-dialog-title {
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0.3px;
}
.ds-dialog-header :deep(.v-btn) {
  position: relative;
  z-index: 1;
}
.ds-dialog-header :deep(.v-btn:hover) {
  background-color: rgba(255, 255, 255, 0.15) !important;
}
.history-table thead th {
  background-color: var(--ds-primary-surface) !important;
  border-bottom: 2px solid var(--ds-primary-border) !important;
  letter-spacing: 0.4px;
  color: var(--ds-primary-deep) !important;
  font-size: 11px !important;
  font-weight: 700 !important;
  text-transform: uppercase;
}
.history-row:hover {
  background-color: var(--ds-primary-surface) !important;
}
.history-row td {
  border-bottom: 1px solid var(--ds-primary-surface) !important;
  color: var(--ds-text-600);
}
.action-btn {
  transition: transform 0.15s ease, background-color 0.15s ease;
}
.action-btn:hover {
  transform: scale(1.15);
}
</style>
